
import { useBannerContext } from "oolib"
import { UIContent } from "../UIContent"

export const extractErrorMsgs = err => {
    const errMsgs = err.response?.data?.errors;
    if(errMsgs) return errMsgs.map(err => err.msg);
    //else
    return [UIContent.general.serverErrorMsg]
}

export const useGenErrorMsgBanners = () => {
    const {SET_ALERT_BANNER} = useBannerContext()
    const genErrorMsgBanners = ({err}) => {
        const errMsgs = extractErrorMsgs(err);
        errMsgs.forEach((msg) => {
            SET_ALERT_BANNER({
                color: "red",
                msg,
                timeOut: 4000
            })
        })
    }

    return {genErrorMsgBanners}
}